import { createAction } from 'typesafe-actions';

export const setProgress = createAction('fileUpload/SET_PROGRESS')<number>();